module.exports = __webpack_public_path__ + "static/riccardo-annandale-7e2pe9wjL9M-unsplash-fit-ba63087a8b5f8383a3aea3d8d482493f.jpg";